import { QueryHookOptions, useQuery } from '@apollo/react-hooks';
import { LIST_SAVED_COUPONS, Coupon } from '@bowtie-web/common';
import { ApiError } from '../error';

type Variables = {
  applicable_product_code?: string;
};

type ListSavedCouponsResponse = {
  savedCoupons: Coupon[];
};

const useListSavedCoupons = (
  variables?: Variables,
  options?: QueryHookOptions<ListSavedCouponsResponse, Variables>,
) => {
  const { applicable_product_code } = variables || {};

  const query = useQuery<ListSavedCouponsResponse, Variables>(
    LIST_SAVED_COUPONS,
    {
      variables: {
        applicable_product_code,
      },
      ...options,
    },
  );

  if (query.error) {
    throw new ApiError(query.error.message);
  }

  // Unique coupon by coupon.code
  const uniqueSavedCoupons: Coupon[] = (query.data?.savedCoupons || []).reduce(
    (result, coupon) => {
      if (!result.some(c => c.code === coupon.code)) {
        result.push(coupon);
      }
      return result;
    },
    [] as Coupon[],
  );

  return [uniqueSavedCoupons, query] as const;
};

export default useListSavedCoupons;
